function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgGold({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "svg-diamond",
    x: "0px",
    y: "0px",
    width: 70,
    height: 70,
    viewBox: "0 0 40 40",
    style: {
      margin: 10
    },
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "ico-diamond",
    transform: "translate(2, 2)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "dimension",
    style: {
      fill: "#FFF3B3",
      stroke: "#D89904",
      strokeWidth: 1
    },
    width: 40,
    height: 35,
    rx: 10,
    ry: 10
  }), /*#__PURE__*/React.createElement("path", {
    id: "icongraphic",
    d: "M21.401,38.92l1.332,7.881l-4.44-5.362c0.002-0.001-14.763-17.838-14.763-17.838         c-0.002,0.001-2.576-3.11-2.576-3.11l5.629,0.529C6.585,21.019,21.402,38.919,21.401,38.92z M6.35,16.951l3.042-4.703         c-0.003-0.002-1.19-5.529-1.19-5.529l-2.193,3.391c0.002,0.001-2.996,4.635-2.996,4.635c-0.002-0.001-2.195,3.389-2.195,3.389         S6.348,16.949,6.35,16.951z M13.879,9.806h20.481c0-0.002,3.997-4.002,3.997-4.002l-4.038,0c0,0.002-20.159,0.002-20.159,0.002         c0-0.002-4.038-0.002-4.038-0.002S13.879,9.803,13.879,9.806z M41.65,16.951c0.003-0.002,5.53,1.183,5.53,1.183         l-2.193-3.391c-0.002,0.001-2.998-4.633-2.998-4.633c0.002-0.001-2.191-3.392-2.191-3.392l-1.188,5.529         C38.609,12.248,41.65,16.951,41.65,16.951z M41.416,21.019L26.598,38.919c0.001,0-1.331,7.882-1.331,7.882l4.44-5.362         c-0.002-0.001,14.763-17.838,14.763-17.838c0.002,0.001,2.577-3.11,2.577-3.11S41.418,21.021,41.416,21.019z M29.619,15.429         H18.382l-1.946,3.008l7.563,17.756l7.564-17.756L29.619,15.429z",
    style: {
      fill: "#D89904",
      stroke: "#D89904",
      strokeWidth: 1
    },
    transform: "scale(0.6) translate(9, 4)"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGold);
export default __webpack_public_path__ + "static/media/gold.d0d6712a.svg";
export { ForwardRef as ReactComponent };